<template>
  <div>
    <!-- <p class="tw-text-2xl tw-mx-2 tw-mt-8 tw-font-semibold">Profile</p> -->
    <v-card>
      <v-tabs
        class="tw-mt-4"
        v-model="tabs"
        dark
        background-color="#212452"
        show-arrows
      >
        <v-tabs-slider color="#212452 lighten-3"></v-tabs-slider>
        <v-tab> Trip Calculator </v-tab>
        <!-- <v-tab> Carbon Audit </v-tab> -->
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <trip-calculator />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- <v-tab-item>
          <v-card flat>
            <v-card-text>
              <carbon-audit />
            </v-card-text>
          </v-card>
        </v-tab-item> -->
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
// import CarbonAudit from "./CarbonAudit.vue";
import TripCalculator from "./TripCalculator.vue";
export default {
  components: {
    // CarbonAudit,
    TripCalculator
  },
  data() {
    return {
      tabs: null,
      items: ["Basic Information", "Account Information", "Change Password"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  }
};
</script>

<style lang="css" scoped></style>
